import React from "react";

const CseSem2MDU = () => {
  return (
    <>
      <div style={{ backgroundColor: "#Dbe6ea" }}>
        <h1 className="mb-1">
          SEMESTER 2 <br />
          Select Your Subject
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h1>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              Math-II
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/19S4AijHBaC32uxJuJyZahqheu-6KJmRz?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1PyUufJKjwEGdryfp9250ySauGLej9EUw/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Physics-II
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/16b4N7Lk1BsG6X38mi_yqM9Nyp6HdUUx0?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1qdyy_Re2BPmIxoUmPfa34KzO6AzXmz6F/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Chemistry
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1wyMOpvh3v_Fey24X0Gbj-eIiHF1O9YvT/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1jBLQJ_VC27c4uuf3wjmnIPpt23_aJCzP?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Elements of Mechanical Engineering
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1NlVYWO63lT2xH8QrjccJWpHoreKWMsyW/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary"> 
                  2019
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              ENGLISH
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1dVzz6Eok1znQ6DzigV6zyLx2TWxcGXpY/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Program for Problem Solving
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/1EvxZwLYegfLAYlvI14et7w9FxbJc7bGi?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CseSem2MDU;
